export default __webpack_public_path__ + "3833a4b22c2f0454e6f8b6558e92788a.webp";